module.exports = __webpack_public_path__ + "static/media/level3_q1.2ab5ff2a.png";